import React, {Component, createRef} from "react";
import styles from './FJMusicFilterPanel.module.less';
import FJCustomScroll from 'fj-components/FJCustomScroll';
import FJFixedLayout from 'fj-components/FJFixedLayout';
import FJMusicCategory from "./FJMusicCategory";
import classNames from 'classnames';
import FJSlider from "fj-components/FJSlider";
import FJUtil from "../../../../../util/FJUtil";

class FJMusicFilterPanel extends Component {

	constructor(props) {
		super(props);
		this.slider = {
			sliderBoxClassName: styles.slider_box,
			railClassName: styles.rail,
			trackClassName: styles.track,
			handleClassName: styles.handle,
		}
		this.sliderRef = createRef();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		this.sliderRef.current.setValue([...this.props.filter.duration])
	}

	onDurationChange = (value) => {
		const {onChange} = this.props;
		onChange('duration', [...value])
	}

	onDurationChangeEnd = (value) => {
		const {onChange} = this.props;
		onChange('duration', [...value], {changeEnd: true});
	}

	_getStartTime = () => {
		let duration = this.props.filter.duration;
		return duration[0] === 240 ? '4:00+' : FJUtil.formatTime(duration[0])
	}

	_getEndTime = () => {
		let duration = this.props.filter.duration;
		return duration[1] === 240 ? '4:00+' : FJUtil.formatTime(duration[1])
	}

	render() {

		let {
			isOpenLeftMenu,
			audioCategories,
			onChange,
			filter,
		} = this.props;

		return (
			<div className={classNames(styles.panel_container, {[styles.active]: isOpenLeftMenu})}>
				<FJCustomScroll>
					<FJFixedLayout basicWidth={270}
					               render={(itemWidth, space, column) => {
						               let lists = [];
						               audioCategories.forEach((item, index) => {
							               if (item.subcategories.length) {
								               return lists.push(
									               <FJMusicCategory key={index}
									                                cate={item.key}
									                                items={item.subcategories}
									                                onChange={onChange}
									                                filter={filter}
									               />
								               )
							               }
						               })
						               lists.push(
							               <FJMusicCategory key='duration' cate='duration'>
								               <FJSlider range
								                         min={0}
								                         max={240}
								                         classes={this.slider}
								                         onChange={this.onDurationChange}
								                         onAfterChange={this.onDurationChangeEnd}
								                         ref={this.sliderRef}
								               />
								               <div className={styles.slider_tag}>
									               <span>{this._getStartTime()}</span>
									               <span>{this._getEndTime()}</span>
								               </div>
							               </FJMusicCategory>
						               )
						               return lists;
					               }}/>
				</FJCustomScroll>
			</div>
		)
	}
}

export default FJMusicFilterPanel;